// eslint-disable-next-line no-restricted-imports
// import {Text} from '@chakra-ui/react';
import {useCurrentAssetOverview} from '../../hooks/current-asset-overview';
import {ListType} from '../../graphql/generated';
import {SoldOutFooterBar} from './product-sold-out-footer';
import {ProductIpoOpenFooter} from './product-ipo-open-footer';
import {MarketplaceFooterBar} from './product-marketplace-footer';

interface ProductFooterLoaderProps {
  assetId?: string;
  purchaseUrl: string | null | undefined;
  color: string;
  price: string;
  darkMode?: boolean;
}

export const ProductFooterLoader: React.FC<ProductFooterLoaderProps> = ({
  assetId,
  color,
  purchaseUrl,
  price,
  darkMode = false,
}) => {
  const asset = useCurrentAssetOverview(assetId || '');

  switch (asset.status) {
    // case 'COMING_SOON':
    //   return (
    //     <ComingSoonFooterBar listType={ListType.VDM} darkMode={darkMode} />
    //   );
    case 'OFFERING_OPEN':
    case 'OFFERING_END':
      return (
        <ProductIpoOpenFooter
          collectors={asset.totalAssetCustomersTransacted || 0}
          color={color}
          link={purchaseUrl || ''}
          price={price}
          currencySymbol={asset.pricing?.symbol || ''}
          currencyPostFix={asset.pricing?.postFix || ''}
          darkMode={darkMode}
          assetId={assetId}
        />
      );
    case 'OFFERING_PENDING':
    case 'OFFERING_CLOSED':
    case 'SOLD_OUT':
      return (
        <SoldOutFooterBar
          listType={ListType.DARWIN}
          collectors={asset.totalAssetCustomersTransacted || 0}
          color={color}
          link={purchaseUrl || ''}
          price={price}
          darkMode={darkMode}
        />
      );
    case 'MARKETPLACE':
      return (
        <MarketplaceFooterBar
          assetId={assetId || ''}
          collectors={asset.totalAssetCustomersTransacted || 0}
          color={color}
          link={purchaseUrl || ''}
          darkMode={darkMode}
        />
      );
    default:
      return <></>;
  }
};
